<template>
	<div class="location-picker-mobile-container">
		<smooth-picker ref="locationPicker" :data="setLocationOptions" :change="handleLocationChange"/>
		<div class="actions">
			<BaseButton title="Choose" @click.prevent="handleChoose"
				:classNames="['button--modifier', 'inline-7']"/>
			<div class="inline-separator"></div>
			<BaseButton title="Remove" @click.prevent="handleRemoveLocation"
				:classNames="['button--modifier', 'inline-7']"/>
		</div>
	</div>
</template>

<script>
	import EventBus from '@EventBus';
	import addressMixin from '@Mixin/addressMixin';
	import serviceMixin from '@Mixin/serviceMixin';
	import pickerMixin from '@Mixin/pickerMixin';
	import alertMixin from '@Mixin/alertMixin';
	import { findIndex, map, compact, each, isEmpty } from 'lodash';

	export default {
		mixins: [
			addressMixin,
			serviceMixin,
			pickerMixin,
			alertMixin,
		],
		data() {
			return {
				locations: [],
				locationsMap: {},
			};
		},
		computed: {
			setLocationOptions() {
				const currentLocation = this.getSelectedAddressId;
				return [
					{
						currentIndex: currentLocation,
						flex: 1,
						list: this.locations,
						textAlign: 'center',
						className: 'row-group',
					},
				]
			},
		},
		methods: {
			updateLocationIndex() {
				if (this.getSelectedAddressId !== null) {
					this.$refs['locationPicker'].currentIndex = this.getSelectedAddressId;
				}
			},
			refreshLocations(locationsMap=false) {
				const isDelivery = this.isForDelivery;
				if (isDelivery) {
					this.locationsMap = locationsMap || this.getLocationsForUserAddresses();
					const selectedAddress = this.getSelectedAddressId || 1;
					this.setSelectedAddressId(selectedAddress);
					const newAddressSelection = {
						name: '- New Address -',
						value: -1,
					};
					const locationMapIndex = Object.keys(this.locationsMap).length;
					this.locationsMap[locationMapIndex] = newAddressSelection;
					this.locations = map(this.locationsMap, 'name');
					this.updateLocationIndex();
					return;
				}
				this.getAllLocations().then((result) => {
					const { nearby } = this.getLocationsSuccessResponse(result);
					this.locationsMap = map(nearby, (nearbyLocation, index) => {
						const ao = nearbyLocation.address_obj; // TODO move into/use model
						const shortAddress = `${ao.street_number} ${ao.street_name}, ${ao.locality}`;
						return {
							name: shortAddress,
							value: index,
						};
					});
					this.setLocations(this.locationsMap);
					this.locations = map(this.locationsMap, 'name');
					this.updateLocationIndex();
				});
			},
			handleRemoveLocation(event) {
				event.stopPropagation();
				const picker = this.$refs['locationPicker'];
				const index = picker.getCurrentIndexList()[0];
				const addressId = this.locationsMap[index].value;
				const street = this.locationsMap[index].name.split(',')[0];
				const vue = this;
				this.customAlert(
					'Remove Address',
					`Are you sure you want to remove this address? ${street}`,
					{
						title: 'Remove',
						handler: () => {
							vue.deleteAddress(addressId).then((response) => {
								vue.$modal.hide('dialog');
								vue.locationsMap.splice(index, 1);
								vue.refreshLocations(vue.locationsMap);
								vue.setSelectedAddressId(null);
								vue.customer.removeAddress(addressId);
								vue.setCustomer(vue.customer)
								vue.removeAddress(addressId);
								picker.change(0,0);
								picker.currentIndexList[0] = 0;
							});
						},
					},
					{
						title: 'Cancel',
						handler: () => {
							vue.$modal.hide('dialog');
						},
					}
				);
			},
			handleLocationChange(groupIndex, itemIndex) {
				const isDelivery = this.isForDelivery;
				let addressId = itemIndex;
				if (isDelivery) {
					addressId = this.addressIdFromIndex(itemIndex);
				}
				this.setSelectedAddressId(addressId);
				EventBus.$emit('location-updated', addressId);
			},
			addressIdFromIndex(itemIndex) {
				const userAddressMap = this.getLocationsForUserAddresses();
				if (!userAddressMap[itemIndex]) {
					EventBus.$emit('new-address');
					return;
				}
				EventBus.$emit('use-address');
				return userAddressMap[itemIndex].value;
			},
			getLocationsForUserAddresses() {
				const userAddresses = this.getUserAddresses();
				let addressMap = [];
				each(userAddresses, (address) => {
					if (!address.id || !address.formattedAddress) {
						return;
					}
					addressMap.push({
						name: address.formattedAddress,
						value: address.id,
					});
				});
				return compact(addressMap);
			},
			handleServiceChange() {
				this.refreshLocations();
				this.$refs['locationPicker'].currentIndex = 0;
			},
		},
		mounted() {
			this.refreshLocations();
		},
		updated() {
			this.updateLocationIndex();
		},
		watch: {
			getServiceType(newValue, oldValue) {
				if (newValue !== oldValue) {
					this.handleServiceChange();
				}
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	.actions {
		display: flex;
		justify-content: center;
		align-items: baseline;
		> * {
			margin: 0.2em 0.5em;
			&.button-wrapper {
				height: 1em;
			}
		}
		> *:first-child {
			margin-left: 0;
		}
		> *:last-child {
			margin-right: 0;
		}
		.inline-separator {
			width: 1px;
			height: 1em;
			background-color: $greySeparator;
		}
	}
	.smooth-picker {
		font-size: 32px;
	}
	@include phone {
		.smooth-picker {
			font-size: 5vw;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseLocationPickerMobile.vue